import type { Recipient } from '@detect/shared';

/** Draft model for the RecipientsEditor (email text + integration ids).
 *  Separate module: components-only files keep Fast Refresh working. */
export interface RecipientsDraft {
  emails: string;
  integrationIds: string[];
}

export function draftToRecipients(draft: RecipientsDraft): Recipient[] {
  const recipients: Recipient[] = draft.emails
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e.length > 0)
    .map((email) => ({ method: 'email' as const, email }));
  for (const integrationId of draft.integrationIds) {
    recipients.push({ method: 'integration', integrationId });
  }
  return recipients;
}

export function recipientsToDraft(recipients: Recipient[]): RecipientsDraft {
  return {
    emails: recipients
      .filter((r) => r.method === 'email' && r.email)
      .map((r) => r.email as string)
      .join(', '),
    integrationIds: recipients
      .filter((r) => r.method === 'integration' && r.integrationId)
      .map((r) => r.integrationId as string),
  };
}
